export interface ISvgRenderProps {
  src: string;
  width?: number;
  height?: number;
}

export const SvgRender: React.FC<ISvgRenderProps> = ({ src, width = 32, height = 32 }) => {
  return <img src={src} width={width} height={height} decoding="async" loading="lazy" />;
};

SvgRender.displayName = 'SvgRender';
